import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

/**
 * PDFViewer is a React component that displays a PDF document.
 * It uses the react-pdf library to render the document and displays
 * each page in the component.
 *
 * @param {Object} props - The component props.
 * @param {Uint8Array|string} props.pdfData - The data for the PDF file to be displayed. This could be a URL or an ArrayBuffer.
 * @param {number} props.width - The width in pixels to render the PDF pages.
 *
 * @returns {JSX.Element} The rendered PDFViewer component.
 */

const PDFViewer = ({ pdfData, width }) => {
    const [numPages, setNumPages] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const handleDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '20px' }}>
            {/* Visible PDF */}
            {pdfData && (
                <Document
                    file={pdfData}
                    onLoadSuccess={handleDocumentLoadSuccess}
                    loading={null}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <div key={`page_${index + 1}`} className="pdf-page-container" style={{ marginBottom: (index + 1 < numPages ? '10px' : '0') }}>
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                loading={null}
                                width={width}
                            />
                        </div>
                    ))}
                </Document>
            )}
        </div>
    );
};

export default PDFViewer;
